import { createSlice } from "@reduxjs/toolkit";
import { changePlan } from "@/store/modules/Subscriptions/thunks";
import { toast } from "react-toastify";

const changePlanSlice = createSlice({
  name: "changePlan",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changePlan.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(changePlan.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        toast.success("Plano alterado com sucesso!");
      })
      .addCase(changePlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as any;
        toast.error("Erro ao alterar plano!");
      });
  },
});

export default changePlanSlice.reducer;
